import React from "react";
 import  { useState, useEffect } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import Loading from './Loading';
import './classes/ManageSortflag.css';
import SalespersonSidebar from "./SalespersonSidebar";
// import { useMockServer } from '@mui/x-data-grid-generator';

 
const columns = [
  
  { field: 'U.first_name', headerName: 'First Name',cellClassName:'first_name_column',headerClassName:'first_name_header',renderCell: (params) => (
      <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.first_name}
      </Link>
      )},
  { field: 'U.last_name', headerName: 'Last Name',cellClassName:'last_name_column',headerClassName:'last_name_header',sortable: false,renderCell: (params) => (
      <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.last_name}
      </Link>
    )},
    { field: 'U.primary_phone', headerName: 'Primary Phone',cellClassName:'phone_column',headerClassName:'phone_header',renderCell: (params) => (
     
      <>{params.row.primary_phone}</>
    
    )},
  { field: 'UA.field_date_of_app', headerName: 'Date of App',cellClassName:'dateofapp_column',headerClassName:'dateofapp_header',renderCell: (params) => (
     
      <>{params.row.field_date_of_app}</>
    
    )}
  
  
];

const SortflagUsers =() =>{
  /* Pagination, filter config starts here */
const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 10 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
 
  const [isLoading, setIsLoading] = useState(true);
  const [sortflagname, setSortflagName] = useState(true);
  var {tid} = useParams();
const app_url = configData.APP_URL;

  React.useEffect(() => {
     
    const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
      try {
         setIsLoading(true);
      const response = await fetch(app_url+'sortflag/sortflagusers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          tid:tid
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
    }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };

    fetchData();
  }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change


  /* Pagination, filter config ends here */
  
/* Pagination, filter config ends here */
  useEffect(() => {
     
      getsortflagname();
      
    },[]);
 async function getsortflagname() {
   
         try {
            const response = await fetch(
                app_url+'sortflag/getsortflagname?tid='+tid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSortflagName(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
       
  }
    return(
       <>
   {isLoading ? (
        <Loading />
      ) : (
        <div id="main">
            <Helmet><title>Sort Flag Users</title></Helmet>
            <div class="left"></div>
               
               <div class="center left-center">
                    <div className="sortflags-container">
                       <h1>Applications By SortFlag : {sortflagname}</h1>

                        <div className="sortflags-users-view-content">
                            <table className="sortflags-views-table">
                                   <div style={{ width: '100%' }}>
                                    <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    rowCount={rowCount}
                                    paginationMode="server"
                                    sortingMode="server"
                                    filterMode="server"
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    sortModel={sortModel}
                                    onSortModelChange={setSortModel}
                                     filterModel={filterModel}
                                    onFilterModelChange={setFilterModel}
                                    pageSizeOptions={[5, 10, 25,50]}
                                    getRowId={() => crypto.randomUUID()}
                                    getRowHeight={() => 'auto'}
                                    disableColumnFilter 
                                    disableColumnResize={true}
                                />
    </div>
                            </table>
                        </div>

                    </div>

                
        </div>
       <div class="right">
            <SalespersonSidebar/>
        </div>
        </div>
        
     )}
    </>
  )
};

export default SortflagUsers;